
<div mat-dialog-content>
   <!-- <div class="full-page-padding pt-0"> 
    <section class="connectors-section">


    <div class="container">
       
            <div class="alert alert-error mb-3" *ngIf="!ifWarehouseEnabled">
              <div class="alert-body">
                <div class="alert-icon"><i class="fa fa-times-circle"></i></div>
                <div class="alert-message"> Let us know where to send your data. <a href="#" class="alert-link" routerLink="/{{baseWord}}/datawarehouses-listing"> Click
                  here</a> to add a destination.
                </div>
              </div>
            </div>
        <div class="my-2">
            <a  href="#" class="gobacklink ml-n3 tooltip hover-tooltip tooltip-sm" routerLink="/{{baseWord}}/integrations-list">
                <span class="button-left-arrow"></span> Go Back To Connectors <div  class="tooltip-section fade-in"><div class="tooltip-body"> Go Back To Connectors </div></div>
            </a>
        </div>
        <div class="row justify-content-between align-items-center">


        <div class="col-9">
            <div class="d-flex align-items-center">
                <div class="col-4">
                    
                    <div class="deatils-logo">
                      <div class="left-logo">
                        <img src="../../assets/images/source-logos/pngFormat/{{integrationInfo?.logoUrl}}" class="img-100"
                             alt="">
                      </div>
                      <div class="center-logo">
                        <img src="../../assets/images/new/daton-with-lines.svg" class="img-fluid" alt="">
                      </div>
                      <div class="right-logo">
                        <img src="../../assets/images/datawarehouselogos/{{warehouseLogoURL}}.png" class="img-100" alt="">
                      </div>
                    </div>
                </div>
                <div class="col-6">
                    <h1 class="text-truncate">{{integrationInfo?.integrationName}} Integrations Details</h1>
                </div>
                <div class="col-2">
                    
                      <label class="toggle-btn " *ngIf="((integrationInfo | json) != '{}')" [ngClass]="{'prevent-click disabled': !(isOrgAdmin || (integrationInfo.userId == userId)) ||
                        (integrationInfo.status === 'DELETED' || integrationInfo.status === 'UPDATED' ) }">
                            <span class="slider {{toggleButton}}"
                                  (click)="onChangeSourceStatus('enable/disable')">
                                <span class="inside-active">Active</span>
                                <span class="inside-pause">Paused</span>
                                <span class="loder"></span>
                            </span>
                      </label>
                      <div *ngIf="!((integrationInfo | json) != '{}')">

                            <div class="ph-item">
                                <div class="w-100">
                                  <div class="row">
                                    <div class="col-md-3">
                                      <div class="ph-picture ph-h-15"></div>
                                    </div>
                                    <div class="col-md-3">
                                      <div class="ph-picture ph-h-15"></div>
                                    </div>
                                    <div class="col-md-12 mt-3">
                                      <div class="ph-picture ph-h-2"></div>
                                    </div>

                                  </div>
                                </div>
                              </div>
                          </div>
                </div>
            </div>

        </div>
        <div class="col-auto">
            <div class="d-flex">
                <div>
                    <button mat-flat-button color="primary" class="btn-sm" (click)="onchangeRenewToken()"
                    [disabled]="!(integrationInfo.status === 'ENABLED') || !(isOrgAdmin || (integrationInfo.userId == userId)) || !(integrationInfo.loginType === 'OAUTH2')"
                    >Re-Authenticate</button>
                </div>
                <div class="ml-2">
                    <button mat-stroked-button color="primary" class="btn-sm"
                    (click)="onChangeSourceStatus('delete',false)"
                    [ngClass]="{'disable-color': (!(isOrgAdmin || (integrationInfo.userId == userId)) || integrationInfo?.nextSyncInfo === 'Deleted')}"
                    [ngClass]="{'not-allowed': (!(isOrgAdmin || (integrationInfo.userId == userId)) || integrationInfo?.nextSyncInfo === 'Deleted')}"
                    [disabled]="!(isOrgAdmin || (integrationInfo.userId == userId)) || integrationInfo?.nextSyncInfo === 'Deleted'">Delete</button>
                </div>
                <div class="ml-2">
                    <button mat-stroked-button color="primary" class="btn-sm"
                    [disabled]="!(isOrgAdmin || userDetails.userId == integrationInfo.userId) || (integrationInfo.status === 'DELETED' || integrationInfo.status === 'PAUSED')"
                      [routerLink]="baseWord | editIntegrationLink:integrationInfo.datasourceId:integrationInfo.integrationName:sourceId"
                      >Settings
                          </button>
                        </div>



            </div>


        </div>
    </div>
    <mat-divider></mat-divider>
    <div class="row mt-3">
        <div class="col-4">
            <div class="label-04">Connection Details</div><br>
            <ng-container *ngIf="integrationInfo?.name !== undefined && integrationInfo?.createdDate !== undefined && integrationInfo?.modifiedDate !== undefined">

                <div class="label-03 mt-2">Integration created by {{integrationInfo.name}} on {{integrationInfo.createdDate}}</div><br>
                <div class="label-03">Modified on {{integrationInfo.modifiedDate}}</div>

            </ng-container>
            <div *ngIf="integrationInfo.name === undefined || integrationInfo.createdDate === undefined || integrationInfo.modifiedDate === undefined">
                <div class="ph-item">
                    <div class="w-100">
                      <div class="row">
                        <div class="col-md-3">
                          <div class="ph-picture ph-h-15"></div>
                        </div>
                        <div class="col-md-3">
                          <div class="ph-picture ph-h-15"></div>
                        </div>
                        <div class="col-md-12 mt-3">
                          <div class="ph-picture ph-h-2"></div>
                        </div>

                      </div>
                    </div>
                  </div>
              </div>

        </div>
        <div class="col-2">
            <div class="label-04" >Replication Frequency</div><br>

            <div class="label-03 mt-2" *ngIf="integrationInfo?.frequency !== undefined">{{integrationInfo.frequency}} hour(s)</div>

            <div *ngIf="integrationInfo?.frequency === undefined">
                <div class="ph-item">
                    <div class="w-100">
                      <div class="row">
                        <div class="col-md-3">
                          <div class="ph-picture ph-h-15"></div>
                        </div>
                        <div class="col-md-3">
                          <div class="ph-picture ph-h-15"></div>
                        </div>
                        <div class="col-md-12 mt-3">
                          <div class="ph-picture ph-h-2"></div>
                        </div>

                      </div>
                    </div>
                  </div>
              </div>

        </div>
        <div  [ngClass]="markedAsTemplate === true ? 'col-2' : 'col-3'">
            <div class="label-04" >Sync Status</div><br>
            <div class="label-03 mt-2" *ngIf="integrationInfo.lastSyncTime !== undefined">Last sync Completed {{integrationInfo.lastSyncTime}} ago <i class="fa fa-check-circle text-{{integrationInfo.lastSyncStatus}}"></i></div>
            
            <div *ngIf="integrationInfo.lastSyncTime === undefined">
                <div class="ph-item">
                    <div class="w-100">
                      <div class="row">
                        <div class="col-md-3">
                          <div class="ph-picture ph-h-15"></div>
                        </div>
                        <div class="col-md-3">
                          <div class="ph-picture ph-h-15"></div>
                        </div>
                        <div class="col-md-12 mt-3">
                          <div class="ph-picture ph-h-2"></div>
                        </div>

                      </div>
                    </div>
                  </div>
              </div>

        </div>
        <div [ngClass]="markedAsTemplate === true ? 'col-2' : 'col-3'">
          
            <div class="sync-flex" *ngIf="integrationInfo.nextSyncInfo !== undefined">
                <div *ngIf="!(['Paused','Deleted','Updated','Scheduled','Sync in progress','Attempting to start','-/-'].includes(integrationInfo.nextSyncInfo))" (click)="startSource(integrationInfo)">
                    <span class="sync-now">
                        <i class="cloud-icon"></i>
                        <span>Sync now</span>
                    </span>
                </div>
                <div class="ml-2" >
                    <div class="label-04" *ngIf="!(['Paused','Deleted','Updated','Scheduled','Sync in progress','Attempting to start','-/-'].includes(integrationInfo.nextSyncInfo))">Next sync will run</div><br>
                     <div class="label-03 mt-2" *ngIf="!(['Paused','Deleted','Updated','Scheduled','Sync in progress','Attempting to start','-/-'].includes(integrationInfo.nextSyncInfo))">after {{integrationInfo.nextSyncInfo}}</div>
                     <div class="label-03 mt-2" *ngIf="(['Paused','Deleted','Updated','Scheduled','Sync in progress','Attempting to start','-/-'].includes(integrationInfo.nextSyncInfo))"
                      >{{integrationInfo.nextSyncInfo}}</div>
                      <span class="loading-dots"
                      *ngIf="integrationInfo.nextSyncInfo === 'Sync in progress' ||
                      integrationInfo.nextSyncInfo === 'Attempting to start'"></span>
                </div>

            </div>
            <div *ngIf="integrationInfo.nextSyncInfo === undefined">
              <br>
                <div class="ph-item">
                    <div class="w-100">
                      <div class="row">
                        <div class="col-md-3">
                          <div class="ph-picture ph-h-15"></div>
                        </div>
                        <div class="col-md-3">
                          <div class="ph-picture ph-h-15"></div>
                        </div>
                        <div class="col-md-12 mt-3">
                          <div class="ph-picture ph-h-2"></div>
                        </div>

                      </div>
                    </div>
                  </div>
              </div>
           

        </div>
        <div *ngIf="markedAsTemplate === true" class="col-2 sync-flex">
          <div class="d-flex">
            <label class="label-checkbox keeplogged">{{integrationInfo.template === true ? 'Marked as template': 'Mark as template'}}
              <input type="checkbox" [(ngModel)]="integrationInfo.template" [ngModelOptions]="{standalone: true}" (change)="toggleAgentTemplate()">
              <span class="checkmark"></span>
            </label>
          </div>
        </div>
    </div>
    </div>
    </section>
    <div class="container">
    <mat-tab-group (selectedTabChange)="onTabChanged($event);" class="mat-tab-padding connectors-tabs">
      <mat-tab label="Tables">

Hello


      </mat-tab>
      <mat-tab label="Notification">
        Hello2
      </mat-tab>
     
    </mat-tab-group>
</div>

  </div>  -->
  <div class="full-page-padding pt-0"> 
    <section class="connectors-section">
  
  
    <div class="container">

    </div>
    </section>
    <div class="container">
    <mat-tab-group  class="mat-tab-padding connectors-tabs-cron">
      <mat-tab label="Scheduler">
  
        <div >
          <label>Occurs Every</label>
          <div class="display-flx">
            <!-- <div class="input-group mb-3">
              <input type="number" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default">
              <input type="number" class="form-control" aria-label="Sizing example input" aria-describedby="inputGroup-sizing-default">
            </div> -->
            <mat-form-field class="time-mat-form-field">
              <label>
                <input matInput type="number"
                  name="minute"                  
                >
              </label>
            </mat-form-field>
            <mat-form-field class="time-mat-form-field">
              <label>
                <input matInput type="number"
                  name="minute"                  
                >
              </label>
            </mat-form-field>
            <section class="example-section">
              <mat-checkbox class="example-margin">Daily</mat-checkbox>
              <mat-checkbox class="example-margin" >Weekly</mat-checkbox>
              <mat-checkbox class="example-margin" >Monthly</mat-checkbox>
            </section>
          </div>
          <label>On Day(s)</label>

          <div style="width: 60%;">
            <section class="example-section">
              <div class="row">

                <mat-checkbox class="example-margin col-3">Sunday</mat-checkbox>
                <mat-checkbox class="example-margin col-3">Monday</mat-checkbox>
                <mat-checkbox class="example-margin col-3">Tuesday</mat-checkbox>
                <mat-checkbox class="example-margin col-3">Wednesday</mat-checkbox>
                <mat-checkbox class="example-margin col-3">Thursday</mat-checkbox>
                <mat-checkbox class="example-margin col-3">Friday</mat-checkbox>
                <mat-checkbox class="example-margin col-3">Saturday</mat-checkbox>

              </div>
              
              
            </section>
            
          </div>
        </div>
  
  
      </mat-tab>
      <mat-tab label="Cron Expression">
        Hello2
      </mat-tab>
     
    </mat-tab-group>
  </div>
  
  </div> 
</div>
<!-- <div mat-dialog-actions>
  <button mat-button (click)="onNoClick()">No Thanks</button>
  <button mat-button [mat-dialog-close]="data.animal" cdkFocusInitial>Ok</button>
</div> -->

